/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {ButtonEl} from 'common/components/button';
import {TooltipEl} from 'common/components/tooltip';
import {RestrictEntitySaving} from 'common/report/constants';
import {currentProjectStore} from 'common/report/stores/project-details';
import {SelectTheme} from 'common/components/select/constants';
import {SelectEl} from 'common/components/select';
import {Directions} from 'common/components/drop-menu/types';
import {ButtonLayout, ButtonTheme} from 'common/components/button/constants';

import type {CreateCohortButton} from './index';

export function template(this: CreateCohortButton) {
  const {cohortDetails} = this.state;
  if (
    !currentProjectStore.value?.canSaveEntity(RestrictEntitySaving.Cohorts) &&
    !this.attr(`show-upsell-in-dropdown`)
  ) {
    return (
      <div>
        <ButtonEl
          attrs={{
            theme: this.attr(`theme`) as ButtonTheme,
            icon: `share`,
            layout: this.attr(`layout`),
          }}
          on={{
            click: this.handleUpsell,
          }}
        >
          {/* sometimes we have no label button */}
          {this.attr(`label`) && <span sel='.button-label'>Upgrade to Create Cohort</span>}
        </ButtonEl>
        <TooltipEl attrs={{'max-width': `250px`}}>
          When you upgrade your plan, cohorts can be created and saved to use across all reports in a project.
        </TooltipEl>
      </div>
    );
  }
  if (this.attr(`disabled`)) {
    return (
      <div>
        <ButtonEl
          attrs={{
            theme: this.attr(`theme`) as ButtonTheme,
            disabled: this.attr(`disabled`),
            icon: this.attr(`icon`),
            layout: this.attr(`layout`),
          }}
        >
          {this.attr(`label`)}
        </ButtonEl>
        {this.attr(`tooltip`) && <TooltipEl attrs={{'max-width': `250px`}}>{this.attr(`tooltip`)}</TooltipEl>}
      </div>
    );
  }
  if (cohortDetails.length === 1 && currentProjectStore.value?.canSaveEntity(RestrictEntitySaving.Cohorts)) {
    return (
      <ButtonEl
        attrs={{
          theme: this.attr(`theme`) as ButtonTheme,
          disabled: this.attr(`disabled`),
          icon: this.attr(`icon`),
          layout: this.attr(`layout`),
        }}
        on={{
          click: this.handleClick,
        }}
      >
        {this.attr(`label`)}
      </ButtonEl>
    );
  }

  if (this.checkRenderUpsellModal()) {
    return (
      <ButtonEl
        attrs={{
          theme: this.attr(`theme`) as ButtonTheme,
          disabled: this.attr(`disabled`),
          icon: `brand-upgrade`,
          layout: this.attr(`layout`),
        }}
        on={{
          click: this.handleClick,
        }}
      >
        Save Cohort
      </ButtonEl>
    );
  }

  return (
    <div>
      <SelectEl
        attrs={{
          icon: {
            leftIcon: this.attr(`icon`),
          },
          'icon-only': !!this.attr(`icon`) && !this.attr(`label`),
          layout: this.attr(`layout`),
          theme: this.attr(`theme`) as SelectTheme,
          ...(this.attr(`layout`) === ButtonLayout.Vertical
            ? {
                'menu-width': 230,
              }
            : {}),
          'menu-alignment': Directions.DownCenter,
          'selected-option': this.attr(`label`),
          disabled: this.attr(`disabled`),
        }}
        props={{
          sections: [
            {
              items:
                this.attr(`show-upsell-in-dropdown`) &&
                !currentProjectStore.value?.canSaveEntity(RestrictEntitySaving.Cohorts)
                  ? [
                      {
                        value: `upsell`,
                        label: `Upgrade to Create Cohort`,
                        icon: `share`,
                      },
                    ]
                  : cohortDetails.map((cohortDetail) => ({
                      value: cohortDetail.type,
                      label: cohortDetail.label,
                    })),
            },
          ],
        }}
        on={{
          change: this.handleClick,
        }}
      />
      {this.attr(`tooltip`) && <TooltipEl attrs={{'max-width': `250px`}}>{this.attr(`tooltip`)}</TooltipEl>}
    </div>
  );
}
